namespace Matrix.Data {
    export namespace ExtensionFieldService {
        export const baseUrl = 'Data/ExtensionField';

        export declare function Restart(request: Serenity.ServiceRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Create(request: Serenity.SaveRequest<ExtensionFieldRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ExtensionFieldRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: ExtensionFieldDeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: ExtensionFieldRetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ExtensionFieldRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ExtensionFieldRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Parse(request: ExtensionFieldParseViewRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Restart = "Data/ExtensionField/Restart",
            Create = "Data/ExtensionField/Create",
            Update = "Data/ExtensionField/Update",
            Delete = "Data/ExtensionField/Delete",
            Retrieve = "Data/ExtensionField/Retrieve",
            List = "Data/ExtensionField/List",
            Parse = "Data/ExtensionField/Parse"
        }

        [
            'Restart', 
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'Parse'
        ].forEach(x => {
            (<any>ExtensionFieldService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
